var _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHamburger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 26 0)",
    fill: "#000A66"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 18 7)",
    fill: "#000A66"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    rx: 1,
    transform: "matrix(-1 0 0 1 26 14)",
    fill: "#000A66"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHamburger);
export default __webpack_public_path__ + "static/media/ic-hamburger.8f24ac28c23ba4a6d71107c40fc9ab33.svg";
export { ForwardRef as ReactComponent };